<template>
    <span>
        <md-icon v-for="n in num" :key="'s' + n" style="color: goldenrod; font-size: 12px !important;">star</md-icon>
        <md-icon v-for="n in notNum" :key="'ns' + n" style="color: lightgray; font-size: 12px !important;">star</md-icon>
    </span>
</template>

<script>
export default {
    name: "stars",
    props: [ 'num' ],
    computed: {
        notNum () {
            return 5 - this.num;
        }
    }
}
</script>
